import { Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";

const getDynamicWidth = (n: number) => ({
  minWidth: 80 * n,
  flex: 1 * n,
});

const userLevelIcon = (userLevel: number) =>
  `https://cafe.pstatic.net/levelicon/1/1_${userLevel}.gif`;

export const cafeTableHeader: GridColDef[] = [
  {
    field: "id",
    headerName: " ",
    align: "center",
    headerAlign: "center",
    ...getDynamicWidth(0.5),
  },
  {
    field: "title",
    headerName: "제목",
    align: "left",
    headerAlign: "center",
    ...getDynamicWidth(5),
    renderCell: ({ row: { title, comment } }) => (
      <>
        <Typography sx={{ fontSize: "inherit" }}>{title}</Typography>
        &nbsp;
        {comment > 0 && (
          <Typography
            sx={{ fontSize: "inherit", color: "red", fontWeight: "bold" }}
          >
            [{comment}]
          </Typography>
        )}
      </>
    ),
    cellClassName: "clickable",
  },
  {
    field: "userName",
    headerName: "작성자",
    align: "left",
    headerAlign: "center",
    ...getDynamicWidth(1.5),
    renderCell: ({ row: { userName, userLevel } }) => (
      <>
        <Typography sx={{ fontSize: "inherit" }}>{userName}</Typography>
        &nbsp;
        <img src={userLevelIcon(userLevel)} alt="" />
      </>
    ),
  },
  {
    field: "postCreatedAt",
    headerName: "작성일",
    align: "center",
    headerAlign: "center",
    ...getDynamicWidth(1.5),
  },
  {
    field: "view",
    headerName: "조회",
    align: "center",
    headerAlign: "center",
    ...getDynamicWidth(1),
  },
  {
    field: "like",
    headerName: "좋아요",
    align: "center",
    headerAlign: "center",
    ...getDynamicWidth(1),
  },
];
